import React from 'react';

type SvgProps = {
    color?: string;
    size?: number;
};

const Ruhender_Verkehr_Bilanzierendes_Parken_Icon: React.FC<SvgProps> = ({ color = "white", size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100.436 66.3506C100.436 72.9917 98.1614 78.0917 93.6484 81.6507C89.1355 85.2097 82.6412 87.0075 74.2391 87.0075H66.534V112.764H58.9023V47.2715H75.8901C92.2542 47.2715 100.436 53.619 100.436 66.3506ZM66.534 80.4766H73.3952C80.1463 80.4766 85.0261 79.3759 88.0348 77.2111C91.0434 75.0463 92.5477 71.524 92.5477 66.7176C92.5477 62.3881 91.1168 59.1593 88.2916 57.0312C85.4664 54.9032 81.0268 53.8391 75.0463 53.8391H66.534V80.4766Z" fill={color} fillOpacity="0.8" />
        <path d="M118.342 139.072H41.658C30.2105 139.072 20.9277 129.789 20.9277 118.342V41.658C20.9277 30.2105 30.2105 20.9277 41.658 20.9277H118.342C129.789 20.9277 139.072 30.2105 139.072 41.658V118.342C139.072 129.789 129.789 139.072 118.342 139.072ZM41.658 25.6975C32.8522 25.6975 25.6975 32.8522 25.6975 41.658V118.342C25.6975 127.147 32.8522 134.302 41.658 134.302H118.342C127.147 134.302 134.302 127.147 134.302 118.342V41.658C134.302 32.8522 127.147 25.6975 118.342 25.6975H41.658Z" fill={color} fillOpacity="0.8" />
    </svg>



);

export default Ruhender_Verkehr_Bilanzierendes_Parken_Icon;
